<template>
	<div :class="['swipeout-action', type, { small }]" :title="type">
		<v-btn class="btn" v-bind="$attrs" fab icon @click="$emit('click', item)">
			<v-icon :small="small" color="light-grey">{{ icons[type] }}</v-icon>
		</v-btn>
	</div>
</template>

<style lang="scss" scoped>
.swipeout-action {
	&.remove {
		background-color: var(--v-rust-red-base);
	}

	&.rename {
		background-color: var(--v-orange-base);
	}

	&.move {
		background-color: var(--v-warm-blue-base);
	}

	&.small .btn {
		height: 40px;
	}
}
</style>

<script>
const icons = {
	remove: "fa-trash",
	rename: "fa-pencil-alt",
	move: "fa-stream",
};

export default {
	inheritAttrs: false,

	props: {
		type: {
			type: String,
			required: true,
			validator: val => Object.keys(icons).indexOf(val) !== -1,
		},

		item: { type: Object, required: true },

		small: { type: Boolean, default: false },
	},

	data: () => ({ icons }),
};
</script>
